/* Spanish catalog mirroring locale-demo-reset-shortcut-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'demoReset.button': 'Restablecer demo',
  'demoReset.title': 'Restablecer la empresa de demostración',
  'demoReset.message': 'Esto elimina de forma permanente todos los datos contables y operativos de esta empresa de demostración. No se puede deshacer.',
  'demoReset.preserved': 'Se conservan el perfil de la empresa, los miembros, la suscripción y las conexiones de integración.',
  'demoReset.phrase': 'CONFIRMAR',
  'demoReset.typeLabel': 'Escribe {phrase} para habilitar el restablecimiento',
  'demoReset.typeHint': 'Comprueba que está seleccionada la empresa de demostración correcta antes de continuar.',
  'demoReset.confirm': 'Eliminar y restablecer demo',
  'demoReset.complete': 'La empresa de demostración se ha restablecido.',
  'demoReset.failed': 'No se pudo restablecer la empresa de demostración.',
  'demoReset.reason': 'El usuario confirmó el acceso directo para restablecer la empresa de demostración escribiendo la frase de confirmación requerida.',
  'demoReset.settingTitle': 'Mostrar acceso directo de restablecimiento',
  'demoReset.settingHelp': 'Muestra «Restablecer demo» sobre SuperPlumma para esta empresa. Las demás empresas de la cuenta de demostración se configuran por separado.',
  'demoReset.settingEnabled': 'El acceso directo está habilitado para esta empresa de demostración.',
  'demoReset.settingDisabled': 'El acceso directo está deshabilitado.',
});
